import { useState } from "react";
import Button from "../components/Button";
import { useLanguage } from "../LanguageContext";
import { useAuth } from "../AuthContext";
import styles from "./AccountPage.module.css";

const LANGUAGES = ["ENGLISH", "SPANISH", "PORTUGUESE (BR)", "FRENCH", "ARABIC"];

function toTitleCase(str) {
  return str.split(" ").map((w) => w.charAt(0) + w.slice(1).toLowerCase()).join(" ");
}

export default function AccountPage() {
  const { langName, setLangName, t } = useLanguage();
  const { user, updateProfile } = useAuth();
  const [name, setName] = useState(user.username || "");
  const email = user.email;
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null); // { tone: "error" | "ok", text }
  const changed = name.trim() !== (user.username || "");

  const saveName = async () => {
    if (saving || !changed) return;
    setSaving(true);
    setMessage(null);
    try {
      const saved = await updateProfile({ username: name });
      setName(saved.username);
      setMessage({ tone: "ok", text: t("acc_saved") });
    } catch (err) {
      setMessage({ tone: "error", text: err.message });
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className={styles.page}>
      <h1 className={styles.title}>{t("nav_account")}</h1>

      <div className={styles.fields}>
        <div className={styles.field}>
          <label className={styles.label}>{t("acc_full_name")}</label>
          <input
            className={styles.input}
            value={name}
            onChange={(e) => setName(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") saveName(); }}
            maxLength={32}
          />
          <div className={styles.saveRow}>
            <Button type="button" onClick={saveName} disabled={saving || !changed || !name.trim()}>
              {saving ? t("acc_saving") : t("acc_save")}
            </Button>
            {message ? (
              <span
                className={message.tone === "error" ? styles.saveError : styles.saveOk}
                role={message.tone === "error" ? "alert" : "status"}
              >
                {message.text}
              </span>
            ) : null}
          </div>
        </div>

        <div className={styles.field}>
          <label className={styles.label}>{t("acc_email")}</label>
          <input
            className={styles.input}
            type="email"
            value={email}
            readOnly
          />
        </div>

        <div className={styles.field}>
          <label className={styles.label}>{t("header_language")}</label>
          <select
            className={styles.select}
            value={langName}
            onChange={(e) => setLangName(e.target.value)}
          >
            {LANGUAGES.map((lang) => (
              <option key={lang} value={lang}>
                {toTitleCase(lang)}
              </option>
            ))}
          </select>
        </div>
      </div>
    </section>
  );
}
